<template>
  <div class="card-body">
    <div class="row">
      <div class="col-lg-6">
        <currencyinput
          name="credit_hire_offer_pre_escalation"
          label="Credit Hire Offer Pre-Escalation"
          helper="Please enter the credit hire offer pre-escalation"
          v-model="form.credit_hire_offer_pre_escalation"
          :show-error="form.errors.has('credit_hire_offer_pre_escalation')"
          :error-message="form.errors.get('credit_hire_offer_pre_escalation')"
        ></currencyinput>

        <currencyinput
          name="recovery_storage_offer_pre_escalation"
          label="Recovery &amp; Storage Offer Pre-Escalation"
          helper="Please enter the recovery &amp; storage offer pre-escalation"
          v-model="form.recovery_storage_offer_pre_escalation"
          :show-error="form.errors.has('recovery_storage_offer_pre_escalation')"
          :error-message="
            form.errors.get('recovery_storage_offer_pre_escalation')
          "
        ></currencyinput>

        <currencyinput
          name="total_claimed_credit_hire"
          label="Total Claimed For Credit Hire"
          helper="The total that was claimed for credit hire"
          v-model="form.total_claimed_credit_hire"
          :show-error="form.errors.has('total_claimed_credit_hire')"
          :error-message="form.errors.get('total_claimed_credit_hire')"
        ></currencyinput>

        <currencyinput
          name="total_claimed_recovery_storage"
          label="Total Claimed For Recovery &amp; Storage"
          helper="The total that was claimed for recovery &amp; storage"
          v-model="form.total_claimed_recovery_storage"
          :show-error="form.errors.has('total_claimed_recovery_storage')"
          :error-message="form.errors.get('total_claimed_recovery_storage')"
        ></currencyinput>

        <currencyinput
          name="total_recovered_credit_hire"
          label="Total Recovered For Credit Hire"
          helper="The total that was recovered for credit hire"
          v-model="form.total_recovered_credit_hire"
          :show-error="form.errors.has('total_recovered_credit_hire')"
          :error-message="form.errors.get('total_recovered_credit_hire')"
        ></currencyinput>

        <currencyinput
          name="total_recovered_recovery_storage"
          label="Total Recovered For Recovery &amp; Storage"
          helper="The total that was recovered for recovery &amp; storage"
          v-model="form.total_recovered_recovery_storage"
          :show-error="form.errors.has('total_recovered_recovery_storage')"
          :error-message="form.errors.get('total_recovered_recovery_storage')"
        ></currencyinput>

        <inputbox
          name="recovery_percentage_credit_hire"
          label="Recovery % For CH"
          helper="Please enter the % recovered for credit hire"
          v-model="form.recovery_percentage_credit_hire"
          :show-error="form.errors.has('recovery_percentage_credit_hire')"
          :error-message="form.errors.get('recovery_percentage_credit_hire')"
        ></inputbox>
      </div>

      <div class="col-lg-6">
        <inputbox
          name="recovery_percentage_recovery_storage"
          label="Recovery % For RS"
          helper="Please enter the % recovered for recovery &amp; storage"
          v-model="form.recovery_percentage_recovery_storage"
          :show-error="form.errors.has('recovery_percentage_recovery_storage')"
          :error-message="
            form.errors.get('recovery_percentage_recovery_storage')
          "
        ></inputbox>

        <currencyinput
          name="credit_hire_settlement"
          label="Credit Hire Settlement"
          helper="Please enter the credit hire settlement"
          v-model="form.credit_hire_settlement"
          :show-error="form.errors.has('credit_hire_settlement')"
          :error-message="form.errors.get('credit_hire_settlement')"
        ></currencyinput>

        <currencyinput
          name="recovery_storage_settlement"
          label="Recovery &amp; Storage Settlement"
          helper="Please enter recovery &amp; storage settlement"
          v-model="form.recovery_storage_settlement"
          :show-error="form.errors.has('recovery_storage_settlement')"
          :error-message="form.errors.get('recovery_storage_settlement')"
        ></currencyinput>

        <datepicker-input
          name="settlement_date"
          label="Settlement Date"
          helper="Please enter the settlement date"
          v-model="form.settlement_date"
        ></datepicker-input>

        <div
          class="form-group has-helper"
          :class="{ 'has-error': form.errors.has('heads_of_claim_settled') }"
        >
          <div class="col-lg-4">
            <label class="control-label">Heads Of Claim Settled:</label>
            <p class="help-block">
              Please select which heads of claims were settled (can be multiple)
            </p>
          </div>
          <div class="col-lg-8">
            <!--
              vue-multiselect is not a native form control, so a disabled
              fieldset does not reach it. Disable it directly instead.
            -->
            <multiselect
              :options="headsOfClaimOptions"
              track-by="id"
              label="label"
              :multiple="true"
              placeholder="Please Select"
              :disabled="isReadonly()"
              v-model="form.heads_of_claim_settled"
            ></multiselect>
            <p
              class="text-danger"
              v-if="form.errors.has('heads_of_claim_settled')"
              v-text="form.errors.get('heads_of_claim_settled')"
            ></p>
          </div>
        </div>

        <selectlist
          :options="settlementTypeOptions"
          label="Settlement Type"
          name="settlement_type"
          helper="Please select the settlement type"
          placeholder="Please Select"
          label-name="label"
          key-name="id"
          v-model="form.settlement_type"
          :show-error="form.errors.has('settlement_type')"
          :error-message="form.errors.get('settlement_type')"
        ></selectlist>

        <selectlist
          :options="settlementMethodOptions"
          label="Settlement Method"
          name="settlement_method"
          helper="Please select the settlement method"
          placeholder="Please Select"
          label-name="label"
          key-name="id"
          v-model="form.settlement_method"
          :show-error="form.errors.has('settlement_method')"
          :error-message="form.errors.get('settlement_method')"
        ></selectlist>
      </div>
    </div>

    <div class="text-right mt-3">
      <form-button :indicator="processing" @clicked="submit">Save</form-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    section: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      processing: false,
      form: new window.Form({
        credit_hire_offer_pre_escalation: null,
        recovery_storage_offer_pre_escalation: null,
        total_claimed_credit_hire: null,
        total_claimed_recovery_storage: null,
        total_recovered_credit_hire: null,
        total_recovered_recovery_storage: null,
        recovery_percentage_credit_hire: null,
        recovery_percentage_recovery_storage: null,
        credit_hire_settlement: null,
        recovery_storage_settlement: null,
        settlement_date: null,
        heads_of_claim_settled: [],
        settlement_type: null,
        settlement_method: null
      }),
      headsOfClaimOptions: [
        { id: 'hire', label: 'Hire' },
        { id: 'recovery', label: 'Recovery & Storage' },
        { id: 'repair', label: 'Repairs' }
      ],
      settlementTypeOptions: [
        { id: 'pre_issue', label: 'Pre Issue' },
        { id: 'issued_awaiting_defence', label: 'Issued Awaiting Defence' },
        {
          id: 'issued_awaiting_allocation_court_directions',
          label: 'Issued Awaiting Allocation/Court Directions'
        },
        { id: 'issued_trial', label: 'Issued Trial' },
        { id: 'judgement_settlement', label: 'Judgement/Settlement' }
      ],
      settlementMethodOptions: [
        { id: 'timed_offer', label: 'Timed Offer' },
        { id: 'calderbank', label: 'Calderbank' },
        { id: 'part_36', label: 'Part 36' },
        { id: 'wop', label: 'WOP' },
        { id: 'global', label: 'Global' },
        { id: 'trial', label: 'Trial' }
      ]
    };
  },

  computed: {
    /**
     * The recovery is loaded into the store by the recovery form, and eager loads
     * its rates and totals, so the figures below need no further requests.
     */
    recovery() {
      return this.$store.getters['DebtRecovery/get'];
    },

    /**
     * Map the rate group names used for these figures onto their ids.
     */
    rateGroupIds() {
      const groups = this.$store.getters['RateGroups/all'] || [];

      return {
        creditHire: (groups.find(group => group.name === 'hire') || {}).id,
        recoveryStorage: (groups.find(group => group.name === 'recovery') || {})
          .id
      };
    },

    /**
     * The figures pulled from the recovery figures and payments pages, used to
     * pre-populate the totals the first time this page is saved.
     */
    totals() {
      return {
        total_claimed_credit_hire: this.claimedFor(
          this.rateGroupIds.creditHire
        ),
        total_claimed_recovery_storage: this.claimedFor(
          this.rateGroupIds.recoveryStorage
        ),
        total_recovered_credit_hire: this.recoveredFor(
          this.rateGroupIds.creditHire
        ),
        total_recovered_recovery_storage: this.recoveredFor(
          this.rateGroupIds.recoveryStorage
        )
      };
    }
  },

  watch: {
    section: {
      handler: 'hydrate',
      immediate: true
    },

    // The rate groups are loaded asynchronously, so the derived figures are not
    // available until they arrive. Re-run the pre-population once they do,
    // otherwise the totals stay blank for the rest of the visit.
    totals: 'prepopulateTotals'
  },

  mounted() {
    this.$store.commit('RateGroups/retrieve');
  },

  methods: {
    hydrate(d) {
      if (!d) {
        this.prepopulateTotals();
        return;
      }

      this.form.total_claimed_credit_hire = d.total_claimed_credit_hire;
      this.form.total_claimed_recovery_storage =
        d.total_claimed_recovery_storage;
      this.form.total_recovered_credit_hire = d.total_recovered_credit_hire;
      this.form.total_recovered_recovery_storage =
        d.total_recovered_recovery_storage;

      this.form.credit_hire_offer_pre_escalation =
        d.credit_hire_offer_pre_escalation;
      this.form.recovery_storage_offer_pre_escalation =
        d.recovery_storage_offer_pre_escalation;
      this.form.recovery_percentage_credit_hire =
        d.recovery_percentage_credit_hire;
      this.form.recovery_percentage_recovery_storage =
        d.recovery_percentage_recovery_storage;
      this.form.credit_hire_settlement = d.credit_hire_settlement;
      this.form.recovery_storage_settlement = d.recovery_storage_settlement;

      // The api returns the date as a utc iso string, so parse it back into
      // a date object to keep the datepicker in the users local timezone.
      this.form.settlement_date = d.settlement_date
        ? window.DateManager.parse(d.settlement_date)
        : null;

      this.form.heads_of_claim_settled = this.headsOfClaimOptions.filter(
        option => (d.heads_of_claim_settled || []).includes(option.id)
      );

      this.form.settlement_type = d.settlement_type;
      this.form.settlement_method = d.settlement_method;

      this.prepopulateTotals();
    },

    /**
     * Pre-populate any total that has not been saved yet with the figure from
     * the recovery figures and payments pages.
     *
     * Once a total has been saved the stored value is kept, so that a handler
     * can override it without it being overwritten on the next visit.
     */
    prepopulateTotals() {
      const derived = this.totals;

      Object.keys(derived).forEach(field => {
        if (this.form[field] === null || this.form[field] === undefined) {
          this.form[field] = derived[field];
        }
      });
    },

    /**
     * Get the recovery total for a rate group.
     */
    totalForGroup(rateGroupId) {
      return ((this.recovery || {}).totals || []).find(
        total => total.rate_group_id === rateGroupId
      );
    },

    /**
     * Get the total claimed for a rate group, inclusive of vat.
     *
     * This is the grand total shown against the group on the figures page.
     */
    claimedFor(rateGroupId) {
      const total = rateGroupId ? this.totalForGroup(rateGroupId) : null;

      if (!total) {
        return null;
      }

      return (total.rate || 0) + (total.rate_vat || 0);
    },

    /**
     * Get the total recovered for a rate group, inclusive of vat.
     *
     * This is the agreed figure shown against the group on the payments page.
     */
    recoveredFor(rateGroupId) {
      const total = rateGroupId ? this.totalForGroup(rateGroupId) : null;

      if (!total) {
        return null;
      }

      return (total.agreed_value || 0) + (total.agreed_value_vat || 0);
    },

    /**
     * Get the form data ready to be sent to the api.
     *
     * The date is formatted in the users local timezone, and the multiselect
     * options are reduced to their ids.
     */
    payload() {
      const data = this.form.data();

      data.settlement_date = data.settlement_date
        ? window.DateManager.format(data.settlement_date, 'YYYY-MM-DD HH:mm:ss')
        : null;

      data.heads_of_claim_settled = (
        this.form.heads_of_claim_settled || []
      ).map(option => option.id);

      return data;
    },

    submit() {
      this.processing = true;

      window.Ajax.put(
        `/debt-recovery/${this.incident}/settlement`,
        this.payload()
      )
        .then(response => {
          this.processing = false;
          this.form.errors.clear();
          this.$emit('saved', response.data);

          window.toastify.success(
            'Success!',
            'The settlement was saved successfully!'
          );
        })
        .catch(error => {
          this.processing = false;

          const data = error.response ? error.response.data : null;

          if (data && data.errors) {
            this.form.errors.record(data.errors);
          }

          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the settlement'
          );
        });
    }
  }
};
</script>
